exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea {\r\n    min-width: 100%;\r\n    max-width: 100%;\r\n    max-height: 100px;\r\n    min-height: 50px;\r\n}\r\n\r\n#letter-pdf {\r\n    background-color: #fff;\r\n    position: relative;\r\n}\r\n\r\n.footer-pdf {\r\n    color: #006293;\r\n    width: 100%;\r\n    position: absolute;\r\n    bottom: 0;\r\n}\r\n\r\n.doc {\r\n    color: #003454;\r\n}\r\n\r\n#letter-pdf > .header-pdf > img, #letter-pdf > .footer-pdf > img {\r\n    width: 100%;\r\n}\r\n\r\n#letter-pdf > .header-pdf {\r\n    padding-bottom: 1rem;\r\n}\r\n\r\n#letter-pdf > .footer-pdf {\r\n    padding-top: 1rem;\r\n}\r\n\r\n#letter-pdf > .body-pdf {\r\n    padding: 2rem;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/configuraciones/carta-saldo/carta-saldo.component.css
// module id = ../../../../../src/app/components/configuraciones/carta-saldo/carta-saldo.component.css
// module chunks = main